import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { setDay } from 'date-fns';
import en from '../../locales/en.json';
import es from '../../locales/es.json';

const getShortDayFormatter = (language: Intl.LocalesArgument) =>
  new Intl.DateTimeFormat(language, { weekday: 'short' });

const initI18n = () => {
  i18n
    .use(Backend)
    .use(initReactI18next)
    .init({
      lng: 'en',
      fallbackLng: 'en',
      resources: {
        en: { translation: en },
        es: { translation: es },
      },
      debug: import.meta.env.NODE_ENV === 'development',
      interpolation: {
        escapeValue: false, // not needed for react as it escapes by default
      },
    });

  // this formatter allows us to display abbreviated localized weekday names by
  // passing {{dayNumber, shortDay}} to an i18n component (dayNumbers begin with Sunday as 0)
  i18n.services.formatter?.add('shortDay', (value, lng, _) => {
    const formatter = getShortDayFormatter(lng);
    const date = setDay(new Date(), value);
    return formatter.format(date);
  });
};

export default initI18n;
